import React, { useEffect, Fragment, } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { groupBy, sumBy, keyBy, omit, mapValues, } from 'lodash';
import { set, } from 'lodash/fp';
import { useAsync, useList, } from 'react-use';
import numeral from 'numeral';
import { arrayMoveImmutable } from 'array-move';

import firebase from '../../firebase';
import { getCollectionData, } from '../../shared/firebase';
import { fields, itemFields, } from '../../shared/models/container';
import { computeLeftQuantities, } from '../../shared/models/purchaseOrder';
import useFormState from '../hooks/useFormState';
import useTenant from '../hooks/useTenant';
import Field from '../Field';
import ListForm from '../ListForm';
import RichTextContent from '../RichTextContent';

const { entries, } = Object;
const db = firebase.firestore();

export default function ContainerFormModal(props) {
  const { isOpen, values, purchaseOrders, otherContainers, products, suppliers, onClickClose, } = props;
  const computedPurchaseOrders = computeLeftQuantities(purchaseOrders, otherContainers);
  const purchaseOrdersById = keyBy(computedPurchaseOrders, 'id');
  const productsById = keyBy(products, 'id');
  const tenant = useTenant();
  const [items, { set: setItems, updateAt: updateItemAt }] = useList(values.items || []);
  const statedFields = useFormState(values, fields({ suppliers }), isOpen);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid) || items.some(_ => !_.isValid);
  const onClickMoveItem = (index, direction) => {
    const newItems = arrayMoveImmutable(items, index, index + ({ up: -1, down: 1 })[direction]);
    setItems(newItems);
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    props.onSubmit({ ...mapValues(statedFields, 'value'), items: items.map(_ => omit(_, 'isValid')), });
  };

  return (
    <Modal isOpen={isOpen} style={{ minWidth: '90vw', }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            コンテナ
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div>
            {
              entries(statedFields).map(([fieldName, fieldSetting]) => {
                return (
                  <Fragment>
                    <Field
                      key={fieldName}
                      name={fieldName}
                      documentName="container"
                      {...fieldSetting}
                    />
                  </Fragment>
                );
              })
            }
          </div>
          <div className="d-flex justify-content-end">
            計: {numeral(sumBy(items, 'quantity')).format()}
          </div>
          <div>
            <ListForm
              items={items}
              renderItem={(item, itemIndex) => {
                return (
                  <div className="card p-3">
                    <ItemForm
                      fields={itemFields({ ...item, purchaseOrders: computedPurchaseOrders, purchaseOrdersById, products, productsById, })}
                      index={itemIndex}
                      values={item}
                      onChange={_ => updateItemAt(itemIndex, { ...item, ..._, })}
                      onClickMove={onClickMoveItem.bind(null, itemIndex)}
                      items={items}
                    />
                  </div>
                );
              }}
              onChange={setItems}
              minItems={0}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
          <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ItemForm (props) {
  const { fields, values, onChange, index, items, onClickMove, } = props;
  const statedFields = useFormState(values, fields, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
    statedFields.startAll();
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex align-items-start flex-wrap gap-1">
        <div style={{ minWidth: 300 }}>
          <Field
            name="productId"
            values={mapValues(statedFields, 'value')}
            {...statedFields.productId}
          />
        </div>
        <div style={{ minWidth: 300 }}>
          <Field
            name="purchaseOrderId"
            values={mapValues(statedFields, 'value')}
            {...statedFields.purchaseOrderId}
          />
        </div>
        <div style={{ minWidth: 300 }}>
          <Field
            name="quantity"
            values={mapValues(statedFields, 'value')}
            {...statedFields.quantity}
          />
        </div>
        <div className="d-flex gap-1">
          <Button size="sm" onClick={onClickMove.bind(null, 'up')} disabled={index === 0}>
            <span className="fas fa-caret-up" />
          </Button>
          <Button size="sm" onClick={onClickMove.bind(null, 'down')} disabled={index === items.length - 1}>
            <span className="fas fa-caret-down" />
          </Button>
        </div>
      </div>
    </div>
  );
}


